import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { WorkflowStatus } from '@devices/models';

const STATUS_TEXTS = {
  [WorkflowStatus.ACTIVE]: 'Active',
  [WorkflowStatus.PAUSED]: 'Paused',
  [WorkflowStatus.ATTEMPTS_EXCEEDED]: 'Attempts Exceeded',
  [WorkflowStatus.DISABLED]: 'Disabled by Super Admin',
  [WorkflowStatus.ATTEMPT_RUNNING]: 'Attempt Running',
  [WorkflowStatus.TWO_WAY_COMMUNICATION_DISABLED]: '2-way communication is disabled',
};

@Component({
  imports: [NgClass],
  selector: 'avs-workflow-status',
  styleUrl: './workflow-status.component.scss',
  template: `<span
    class="workflow-status"
    [ngClass]="{
      'active': status() === eWorkflowStatus.ACTIVE,
      'paused': status() === eWorkflowStatus.PAUSED,
      'attempts-exceeded': status() === eWorkflowStatus.ATTEMPTS_EXCEEDED,
      'disabled': status() === eWorkflowStatus.DISABLED,
      'attempt-running': status() === eWorkflowStatus.ATTEMPT_RUNNING,
      'two-way-communication-disabled': status() === eWorkflowStatus.TWO_WAY_COMMUNICATION_DISABLED,
    }"
    >{{ STATUS_TEXTS[status()] }}</span
  >`,
})
export class WorkflowStatusComponent {
  status = input.required<WorkflowStatus>();
  protected readonly eWorkflowStatus = WorkflowStatus;
  protected readonly STATUS_TEXTS = STATUS_TEXTS;
}
